import { formatUsd } from "../../config/trading";
import { Metric } from "./Metric";

export function MetricsGrid({ portfolio, risk }) {
  return (
    <div className="metrics-grid">
      <Metric testId="portfolio-total-value" label="Portfolio Value" value={formatUsd(portfolio.total_value_usdt)} />
      <Metric testId="portfolio-available-usdt" label="Available USDT" value={formatUsd(portfolio.available_usdt)} />
      <Metric
        testId="portfolio-paper-pnl"
        label="Paper PnL"
        value={`${formatUsd(portfolio.paper_pnl_usdt)} (${portfolio.paper_pnl_pct}%)`}
        tone={portfolio.paper_pnl_usdt >= 0 ? "positive" : "negative"}
      />
      <Metric testId="risk-max-trade" label="Max Trade" value={formatUsd(risk.max_trade_usdt)} />
    </div>
  );
}